import { Component, OnInit, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { authTypeOptionsConstant } from 'src/app/constants/service.constants';
import { CONFIGURATION, LDAP } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { httpOptions, serviceConstants } from 'src/app/constants/service.constants';
import { Document_Upload_File } from 'src/app/models/common';

import * as $ from 'jquery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-ldap-configuration',
  templateUrl: './ldap-configuration.component.html',
  styleUrls: ['./ldap-configuration.component.scss']
})
export class LdapConfigurationComponent implements OnInit {

  formFields;
  chooseoptions = authTypeOptionsConstant;
  ldapConfigurationForm = new UntypedFormGroup({});
  operations = [];
  uploadedFiles = ["Attachement one", "Attachment two", "Attachment three"];
  documaent_attach_list: Document_Upload_File[] = [];


  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  mail: CONFIGURATION;
  ldapconfig: LDAP;
  SavedAttachments = [];

  constructor(
    private summaryService: AdministrationSummaryService,

    private modalService : NgbModal,
    private appFunctions: AppFunctionsService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.ldapconfig = new LDAP();
    this.setForm(this.ldapconfig);
    this.summaryService.getConfiguration('api/configuration/getldapconfig').subscribe((result) => {
      this.mail = result;
      this.setForm(this.mail.LDAP);
    });
  }

  private setForm(result: LDAP): void {

    this.ldapConfigurationForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      LDAPRVER: new UntypedFormControl(result.LDAPRVER),
      LDAPPORT: new UntypedFormControl(result.LDAPPORT),
      LDAPTYPE: new UntypedFormControl(result.LDAPTYPE),
      FILTER: new UntypedFormControl(result.FILTER),
      EMAIL: new UntypedFormControl(result.EMAIL),
      ENABLED: new UntypedFormControl(result.ENABLED),
      USERID: new UntypedFormControl(result.USERID),
      PASSWORD: new UntypedFormControl(result.PASSWORD)
    });
    if (this.mail != null && this.mail.Attachments != null)
      this.SavedAttachments = this.mail.Attachments;
  }

  private getForm(): LDAP {
    const formModel = this.ldapConfigurationForm.value;
    let email = new LDAP();
    email = {
      ID: formModel.ID,
      LDAPRVER: formModel.LDAPRVER,
      LDAPPORT: formModel.LDAPPORT,
      LDAPTYPE: formModel.LDAPTYPE,
      FILTER: formModel.FILTER,
      EMAIL: formModel.EMAIL,
      ENABLED: formModel.ENABLED,
      USERID: formModel.USERID,
      PASSWORD: formModel.PASSWORD
    }

    return email;
  }

  onCallbackOperation(opr){
    opr.callback();
  }

  test_connection(){
    this['self'].modalService.show(MessageBoxComponent, {data:{heading:'Test Connection',content: { heading: '', description: 'Connection working properly.'}}});
  }


  save() {
    if (this.validateControls()) {
      this.mail.LDAP = this.getForm();
      var fromData = this.mail;

      let attachForm = new FormData();
      if (this.documaent_attach_list != null && this.documaent_attach_list.length > 0) {
        for (let i = 0; i < this.documaent_attach_list.length; i++) {
          this.documaent_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          attachForm.append(("" + (i + 1)), this.documaent_attach_list[i].File);
        }
      }

      attachForm.append("ScreenData", JSON.stringify(fromData));

      this.summaryService.saveLDAPconfiguration(attachForm).subscribe(result => {
        if (result.Status === 0) {
          this.commonService.SuccessBanner('LDAP Configuration Saved Successfully.');
          this.summaryService.getConfiguration('api/configuration/getldapconfig').subscribe((result) => {
            this.mail = result;
            this.setForm(this.mail.LDAP);
            this.documaent_attach_list = [];
          });
        }
        else {
          this.commonService.ValidationBanner( result.Message )
        }
      });
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ldapConfigurationForm.value;

    // Representative validations
    if (formData.LDAPRVER === null || formData.LDAPRVER === "" || formData.LDAPRVER === undefined) {
      $("#LDAPRVER").addClass("ng-touched ng-invalid validate-error");
      $("#LDAPRVER").removeClass("ng-untouched ng-valid");
      message += "Please enter LDAPRVER.<br/>";
      isValid = false;
    } else {
      $("#LDAPRVER").addClass("ng-untouched ng-valid");
      $("#LDAPRVER").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.LDAPPORT === null || formData.LDAPPORT === "" || formData.LDAPPORT === undefined) {
      $("#LDAPPORT").addClass("ng-touched ng-invalid validate-error");
      $("#LDAPPORT").removeClass("ng-untouched ng-valid");
      message += "Please enter  LDAPPORT URL.<br/>";
      isValid = false;
    } else {
      $("#LDAPPORT").addClass("ng-untouched ng-valid");
      $("#LDAPPORT").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.USERID === null || formData.USERID === "" || formData.USERID === undefined) {
      $("#USERID").addClass("ng-touched ng-invalid validate-error");
      $("#USERID").removeClass("ng-untouched ng-valid");
      message += "Please enter UserID.<br/>";
      isValid = false;
    } else {
      $("#USERID").addClass("ng-untouched ng-valid");
      $("#USERID").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.PASSWORD === null || formData.PASSWORD === "" || formData.PASSWORD === undefined) {
      $("#PASSWORD").addClass("ng-touched ng-invalid validate-error");
      $("#PASSWORD").removeClass("ng-untouched ng-valid");
      message += "Please enter Password.<br/>";
      isValid = false;
    } else {
      $("#PASSWORD").addClass("ng-untouched ng-valid");
      $("#PASSWORD").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.LDAPTYPE === null || formData.LDAPTYPE === "" || formData.LDAPTYPE === undefined) {
      $("#LDAPTYPE").addClass("ng-touched ng-invalid validate-error");
      $("#LDAPTYPE").removeClass("ng-untouched ng-valid");
      message += "Please enter LDAPTYPE.<br/>";
      isValid = false;
    } else {
      $("#LDAPTYPE").addClass("ng-untouched ng-valid");
      $("#LDAPTYPE").removeClass("ng-touched ng-invalid validate-error");
    }


    // Representative validations
    if (formData.FILTER === null || formData.FILTER === "" || formData.FILTER === undefined) {
      $("#FILTER").addClass("ng-touched ng-invalid validate-error");
      $("#FILTER").removeClass("ng-untouched ng-valid");
      message += "Please enter FILTER.<br/>";
      isValid = false;
    } else {
      $("#FILTER").addClass("ng-untouched ng-valid");
      $("#FILTER").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  uploadchange(event): void {
    if (event.UploadFiles == undefined || event.UploadFiles == null)
      event.UploadFiles = [];

    if (this.documaent_attach_list == undefined || this.documaent_attach_list == null) {
      this.documaent_attach_list = [];
    }
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      uploadFile.ID = ("" + (i + 1));
      uploadFile.DOCUMENT_NAME = event.target.files[i].name;
      uploadFile.File = event.target.files[i];
      uploadFile.Status = "Add";
      this.documaent_attach_list.push(uploadFile);
    }
  }

  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.documaent_attach_list = this.documaent_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  DeleteSavedUpload(item): void {
    this.summaryService.Delete("api/ISTFileAttachments/DeleteFile?FileID=" + item).subscribe(result => {
      let code = item;
      this.SavedAttachments = this.SavedAttachments.filter(function (sec) {
        return sec.ID != code;
      }, code);
    });
  }

  startUpload(url: any, fromData: any): void {
     
    var url1 = serviceConstants.apiURL + url;
    const event: any = {
      type: 'uploadAll',
      url: url1,
      method: 'POST',
      data: fromData,
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }
}
